/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { mapModifiers } from 'libs/component';
import { Heading } from 'components/atoms/heading';
import Default from 'components/templates/default';
import { Section } from 'components/molecules/section';
import {GLANCE_NEW_NEWCHAPTER, GLANCE_VISION_LIST, GLANCE_OPTION_LIST, GLANCE_HISTORY_IMG_LIST, GLANCE_HISTORY_INFO, GLANCE_HISTORY_NEWCHAPTER,GLANCE_WHYQSNCC_IMG_LIST, GLANCE_WHYQSNCC,GLANCE_WHYQSNCC_LOCATION} from 'libs/constants';
import { Waypoint } from 'react-waypoint';
import { useTranslation } from 'react-i18next';
import { OptionList } from 'components/molecules/option-list';
import { useEffect } from 'react';
import { Carousel } from 'components/organisms/carousel';
import { Image as AImage } from 'components/atoms/image';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import { Icon } from 'components/atoms/icon';

export interface GlanceProps {
  currentTab?: number;
  onOptionSelected?: (tab: number) => void;
  onNewsClick?: (slug: string) => void;
}



export const Glance: React.FC<GlanceProps> = ({ currentTab: defaultCurrentTab = 0, onOptionSelected}) => {
  const { i18n } = useTranslation();
  const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  const [, setCurrentTopicIndex] = useState(0);
  // const menuRef = useRef(null);
  const policyRef = useRef(null);
  const optionList = useMemo(() => {
    return GLANCE_OPTION_LIST;
  }, []);

  useEffect(() => {
    setCurrentTab(defaultCurrentTab);
  }, [setCurrentTab, defaultCurrentTab, currentTab]);

  const handleOptionSelected = useCallback(
    (index: number) => {
      setCurrentTab(index);
      if (onOptionSelected) {
        onOptionSelected(index);
      }
    },
    [setCurrentTab, onOptionSelected]
  );

  const glanceVisionList = useMemo(() => {
    return GLANCE_VISION_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const glanceHistoryInfo = useMemo(() => {
    return GLANCE_HISTORY_INFO.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);


  const glanceHistoryNewChapter = useMemo(() => {
    return GLANCE_HISTORY_NEWCHAPTER.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const glanceWhyQSNCC = useMemo(() => {
    return GLANCE_WHYQSNCC.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const glanceWhyQSNCCLocation = useMemo(() => {
    return GLANCE_WHYQSNCC_LOCATION.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const glanceNewList = useMemo(() => {
    return GLANCE_NEW_NEWCHAPTER.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);




  const glanceHistoryImgList: any[] = GLANCE_HISTORY_IMG_LIST;
  const glanceWhyQSNCCImgList: any[] = GLANCE_WHYQSNCC_IMG_LIST;

  // const topics = useMemo(() => {
  //   return glanceVisionList
  //     .filter(x => !x.default && (x.title as any)[i18n.language || 'en'] !== '')
  //     .map(x => (x.title as any)[i18n.language || 'en']);
  // }, [i18n.language, glanceVisionList]);

  // const handleTopicClick = useCallback((index: number) => {
  //   const itemIndex = index + 1;
  //   setCurrentTopicIndex(itemIndex);
  //   // scroll to target
  //   const policyHolderEl = policyRef.current as any;
  //   if (policyHolderEl) {
  //     const menuEl = menuRef.current as any;
  //     const elList = policyHolderEl.querySelectorAll('.t-privacy-policy__info-detail');
  //     if (elList && typeof elList[itemIndex] !== 'undefined' && menuEl) {
  //       const el = elList[itemIndex] as HTMLDivElement;
  //       const bodyRect = document.body.getBoundingClientRect();
  //       const rect = el.getBoundingClientRect();
  //       const menuRect = menuEl.getBoundingClientRect();

  //       if (rect && menuRect) {
  //         const offset = window.innerWidth <= 640 ? menuRect.height / 4 + 120 : 80 * 2;
  //         const topPos = rect.top - bodyRect.top - offset;
  //         window.scrollTo({ top: topPos, left: 0, behavior: 'smooth' });
  //       }
  //     }
  //   }
  // }, []);

  const handleSectionEnter = useCallback((index: number) => {
    setCurrentTopicIndex(index);
  }, []);

  // const handleSelectChanged = useCallback(
  //   (value: string) => {
  //     const index = Number(value);
  //     handleTopicClick(index);
  //   },
  //   [handleTopicClick]
  // );

  const optionItemList = optionList.map(x => (x.label as any)[i18n.language]);

  // const motionVariants = {
  //   headContainer: {
  //     hidden: {
  //       opacity: 0,
  //       y: -20,
  //     },
  //     show: {
  //       opacity: !false ? 1 : 0,
  //       y: !false ? 0 : -20,
  //       transition: {
  //         delay: 0.25,
  //         delayChildren: 0.25,
  //         duration: 0.5,
  //         ease: 'easeInOut',
  //         staggerChildren: 0.25,
  //       },
  //     },
  //   },
  //   headItem: {
  //     hidden: { opacity: 0 },
  //     show: { opacity: !false ? 1 : 0 },
  //   },
  //   projectInfo: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: true ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.25,
  //         delayChildren: 0.25,
  //         duration: 0.5,
  //         ease: 'easeOut',
  //         staggerChildren: 0.25,
  //       },
  //     },
  //   },
  //   projectInfoItem: {
  //     hidden: { opacity: 0 },
  //     show: { opacity: true ? 1 : 0 },
  //   },
  //   projectConcept: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: false ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.25,
  //         delayChildren: 0.25,
  //         duration: 0.5,
  //         ease: 'easeOut',
  //         staggerChildren: 0.25,
  //       },
  //     },
  //   },
  //   projectConceptItem: {
  //     hidden: { opacity: 0 },
  //     show: { opacity: false ? 1 : 0 },
  //   },
  //   projectProgress: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: false ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.25,
  //         duration: 0.5,
  //         ease: 'easeOut',
  //       },
  //     },
  //   },
  //   gallery: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: false ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.5,
  //         duration: 1.5,
  //         ease: 'easeOut',
  //       },
  //     },
  //   },
  //   news: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: false ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.25,
  //         delayChildren: 0.25,
  //         duration: 0.5,
  //         ease: 'easeOut',
  //         staggerChildren: 0.25,
  //       },
  //     },
  //   },
  //   newsItem: {
  //     hidden: { opacity: 0 },
  //     show: { opacity: !false ? 1 : 0 },
  //   },
  //   gettingHere: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: false ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.25,
  //         delayChildren: 0.25,
  //         duration: 0.5,
  //         ease: 'easeOut',
  //         staggerChildren: 0.25,
  //       },
  //     },
  //   },
  //   gettingHereItem: {
  //     hidden: { opacity: 0 },
  //     show: { opacity: !false ? 1 : 0 },
  //   },
  //   gettingHereTab: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: false ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.25,
  //         duration: 0.5,
  //         ease: 'easeOut',
  //       },
  //     },
  //   },
  //   map: {
  //     hidden: { opacity: 0, y: -20 },
  //     show: {
  //       opacity: false ? 1 : 0,
  //       y: 0,
  //       transition: {
  //         delay: 0.25,
  //         duration: 0.5,
  //         ease: 'easeOut',
  //       },
  //     },
  //   },
  //   backToTop: {
  //     hidden: { opacity: 0 },
  //     show: {
  //       opacity: !false ? 1 : 0,
  //       transition: {
  //         delay: 0.5,
  //         duration: 0.5,
  //         ease: 'easeInOut',
  //       },
  //     },
  //   },
  // };

  return (
    <div className={mapModifiers('t-privacy-policy')}>
      <Default>
        <article className="t-privacy-policy__content">
          <Section className="t-privacy-policy__heading">
            <Heading>概览</Heading>
          </Section>

          {/* 愿景、历史、选择QSNCC的理由Tab */}
          <Section className="t-media__tabs">
            <OptionList
              currentIndex={currentTab}
              modifiers="horizontal"
              items={optionItemList}
              onSelected={handleOptionSelected}
            />
          </Section>

          {/* 愿景 */}
          {currentTab === 0 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {glanceVisionList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
           )}



          {/* 历史 */}
          {currentTab === 1 && (
          <Section className="t-privacy-policy__detail ">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {glanceHistoryInfo.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder ">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail history"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
           )}



          {/* 图片轮播样式 */}
          {currentTab === 1 && (
          <div className="t-media__info-news-carousel">
            <Carousel
              mode="gallery"
              modifiers="no-button"
            >
              {glanceHistoryImgList.map((item: any, index: number) => (
                <div key={index} className="t-home__gallery-item history_img" data-attribute="SRL">
                  <AImage
                    src={item.image as any}
                    srcSp={item.imageSp as any}
                    srcWebp={item.imageWebp as any}
                    srcWebpSp={item.imageWebpSp as any}
                    caption={item.caption}
                    align={item.align}
                    lazy={true}
                  />
                </div>
              ))}
            </Carousel>
          </div>
          )}

          {/* 新篇章 */}
          {currentTab === 1 && (
             <div className=' t-title'><strong>新篇章</strong></div>
          )}
          
          {currentTab === 1 && (
             <Section className="t-privacy-policy__detail newcapter " >
             <div className="p-about-glance__now-2022__compare-slider t-privacy-policy__info">
                 <ReactCompareSlider
                   changePositionOnHover
                   handle={
                     <div className="p-about-glance__now-2022__handler">
                       <Icon name="chevron-left" color="white" />
                       <Icon name="chevron-right" color="white" />
                     </div>
                   }
                   itemOne={<ReactCompareSliderImage src="/images/glance/history/now-2022-01.jpg" alt="Previous" />}
                   itemTwo={<ReactCompareSliderImage src="/images/glance/history/now-2022-02.jpg" alt="Current" />}
                 />
               </div>
           </Section>
          )}
          {currentTab === 1 && (
             <Section className="t-privacy-policy__detail newcapter" >
             <div className="t-privacy-policy__info" >
                   {glanceNewList.map((policy: any, index: number) => (
                     <div key={index} className="t-privacy-policy__info-detail-holder">
                       <div
                         className="t-privacy-policy__info-detail"
                         dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                       />
                     </div>
                   ))}
                 </div>
             </Section>
          )}
          {currentTab === 1 && (
            <Section className="t-privacy-policy__detail newcapter" >
              <div className="t-privacy-policy__info" ref={policyRef}>
                {glanceHistoryNewChapter.map((policy: any, index: number) => (
                  <div key={index} className="t-privacy-policy__info-detail-holder">
                    <Waypoint onEnter={() => handleSectionEnter(index)} />
                    <div
                      className="t-privacy-policy__info-detail"
                      dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                    />
                  </div>
                ))}
              </div>
            </Section>
           )}

           {/* 选择QSNCC的理由 */}

           {currentTab === 2 && (
             <div className='title'>不止于会奖 不止于场地</div>
          )}

           {currentTab === 2 && (
            //  <div className="t-media__info-news-carousel" glanceWhyQSNCCImgList>
            <Carousel
               mode="gallery"
               modifiers="no-button"
             >
               {glanceWhyQSNCCImgList.map((item: any, index: number) => (
                 <div key={index} className="t-home__gallery-item mrt_img" data-attribute="SRL">
                   <AImage
                     src={item.image as any}
                     srcSp={item.imageSp as any}
                     srcWebp={item.imageWebp as any}
                     srcWebpSp={item.imageWebpSp as any}
                     caption={item.caption}
                     align={item.align}
                     lazy={true}
                   />
                 </div>
               ))}
             </Carousel>

             

             
          //  </div>
           )}



          
            {/* 选择QSNCC的理由 */}

          {currentTab === 2 && (
          <Section className="t-privacy-policy__detail newcapter" >
            <div className="t-privacy-policy__info" ref={policyRef}>
              {glanceWhyQSNCC.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
           )}


          {currentTab === 2 && (
             <div className='whyqsncc'></div>
          )}

           {currentTab === 2 && (
             <div className='titleend'>QSNCC地理位置优越，拥有灵活的空间、服务和尖端技术，提供可持续发展以及安全保障。</div>
          )}
        
        {currentTab === 2 && (
              <Section className="t-news-detail__excerpt" >
              <div className="t-privacy-policy__info" ref={policyRef}>
                {glanceWhyQSNCCLocation.map((policy: any, index: number) => (
                  <div key={index} className="t-privacy-policy__info-detail-holder">
                    <Waypoint onEnter={() => handleSectionEnter(index)} />
                    <div
                      className="t-news-detail__excerpt-main"
                      dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                    />
                  </div>
                ))}
              </div>
            </Section>
          )}
        









        </article>
      </Default>
    </div>
  );
};
